import React, { useState } from 'react';
import {
  Link, useLocation
} from "react-router-dom";
import './Header4.css';
import logosaars from '../../../assets/images/logo_sarsindialiaison.jpg'; // Import your logo image
import { FaCaretRight } from 'react-icons/fa';
import IsoCertificateBatch from '../../iso_cerificate_batch/IsoCertificateBatch';





const MegaMenuNavbar = () => {
  const location = useLocation();
  const [isMenuOpen, setMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null); // For mobile toggle

  const toggleMenu = () => setMenuOpen(!isMenuOpen);
  const toggleDropdown = (index) => {
    setActiveDropdown(activeDropdown === index ? null : index); // Toggle dropdown on mobile
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="logo">
          <img src={logosaars} alt="Logo" className="logo-img" />
        </div>
        <button className="menu-toggle" onClick={toggleMenu}>
          ☰
        </button>
        <ul className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
          <li><Link to="/">Home</Link></li>
          <li><Link to="/about">About</Link></li>
          <li className="dropdown" onClick={() => toggleDropdown(0)}>
            <Link to="/services" >Services</Link>
            <div className={`dropdown-menu_jj7 ${activeDropdown === 0 ? 'active' : ''}`}>
              <div className='container_inside_dropdown_menu'>
                <h3>Engineering</h3>
                <li><Link to="/peso" className={location.pathname === '/peso' ? 'active' : ''}><FaCaretRight style={{ marginRight: '0.5rem' }} />PESO</Link></li>
                <li><Link to="/architectural-design" className={location.pathname === '/architectural-design' ? 'active' : ''}><FaCaretRight style={{ marginRight: '0.5rem' }} />Architectural Plans</Link></li>
              </div>
              <div className='container_inside_dropdown_menu'>
                <h3>Licensing</h3>
                <li><Link to="/peso" className={location.pathname === '/peso' ? 'active' : ''}><FaCaretRight style={{ marginRight: '0.5rem' }} />PESO</Link></li>
                <li><Link to="/forest-clearance" className={location.pathname === '/forest-clearance' ? 'active' : ''}><FaCaretRight style={{ marginRight: '0.5rem' }} />FC</Link></li>
                <li><Link to="/environmental-clearance" className={location.pathname === '/environmental-clearance' ? 'active' : ''}><FaCaretRight style={{ marginRight: '0.5rem' }} />EC</Link></li>
                <li><Link to="/consent-to-estalish" className={location.pathname === '/consent-to-estalish' ? 'active' : ''}><FaCaretRight style={{ marginRight: '0.5rem' }} />CTE</Link></li>
                <li><Link to="/consent-to-operate" className={location.pathname === '/consent-to-operate' ? 'active' : ''}><FaCaretRight style={{ marginRight: '0.5rem' }} />CTO</Link></li>
                <li><Link to="/hazardous-waste-licensing" className={location.pathname === '/hazardous-waste-licensing' ? 'active' : ''}><FaCaretRight style={{ marginRight: '0.5rem' }} />Hazardous Waste</Link></li>
                <li><Link to="/bio-medical-waste-authorization" className={location.pathname === '/bio-medical-waste-authorization' ? 'active' : ''}><FaCaretRight style={{ marginRight: '0.5rem' }} />Bio-Medical Waste Authorization</Link></li>
                <li><Link to="/fire-licensing" className={location.pathname === '/fire-licensing' ? 'active' : ''}><FaCaretRight style={{ marginRight: '0.5rem' }} />Fire Licensing</Link></li>
                <li><Link to="/clinical-establishment-licensing" className={location.pathname === '/clinical-establishment-licensing' ? 'active' : ''}><FaCaretRight style={{ marginRight: '0.5rem' }} />Clinical Establishment</Link></li>
              </div>
              <div className='container_inside_dropdown_menu'>
                <h3>NOCs</h3>
                <li><Link to="/fire-nocs" className={location.pathname === '/fire-nocs' ? 'active' : ''}><FaCaretRight style={{ marginRight: '0.5rem' }} />Fire </Link></li>
                <li><Link to="/cgwanoc" className={location.pathname === '/cgwanoc' ? 'active' : ''}><FaCaretRight style={{ marginRight: '0.5rem' }} />CGWA</Link></li>
                <li><Link to="/airport-height-clearance-noc" className={location.pathname === '/airport-height-clearance-noc' ? 'active' : ''}><FaCaretRight style={{ marginRight: '0.5rem' }} />Airport Height Clearance </Link></li>
                <li><Link to="/water-allocatio-norder-noc" className={location.pathname === '/water-allocatio-norder-noc' ? 'active' : ''}><FaCaretRight style={{ marginRight: '0.5rem' }} />Water Allocation Order</Link></li>
                <li><Link to="/various-govt-officials-nocs" className={location.pathname === '/various-govt-officials-nocs' ? 'active' : ''}><FaCaretRight style={{ marginRight: '0.5rem' }} />Various Govt Officials </Link></li>

              </div>
              <div className='container_inside_dropdown_menu'>
                <h3>Compliance and Audit</h3>
                <li><Link to="/peso-compliance" className={location.pathname === '/peso-compliance' ? 'active' : ''}><FaCaretRight style={{ marginRight: '0.5rem' }} />PESO </Link></li>
                <li><Link to="/forest-clearance-compliance" className={location.pathname === '/forest-clearance-compliance' ? 'active' : ''}><FaCaretRight style={{ marginRight: '0.5rem' }} />FC</Link></li>
                <li><Link to="/environment-clearance-compliance" className={location.pathname === '/environment-clearance-compliance' ? 'active' : ''}><FaCaretRight style={{ marginRight: '0.5rem' }} />EC </Link></li>
                <li><Link to="/consent-to-operate-compliance" className={location.pathname === '/consent-to-operate-compliance' ? 'active' : ''}><FaCaretRight style={{ marginRight: '0.5rem' }} />CTO</Link></li>
                <li><Link to="/cgwa-compliance" className={location.pathname === '/cgwa-compliance' ? 'active' : ''}><FaCaretRight style={{ marginRight: '0.5rem' }} />CGWA</Link></li>

              </div>
              <div className='container_inside_dropdown_menu'>
                <h3>Miscellaneous</h3>
                <li><Link to="/feasibility-study-for-construction" className={location.pathname === '/feasibility-study-for-construction' ? 'active' : ''}><FaCaretRight style={{ marginRight: '0.5rem' }} />Feasibility Study for Construction</Link></li>
                <li><Link to="/environment-impact-assesment" className={location.pathname === '/environment-impact-assesment' ? 'active' : ''}><FaCaretRight style={{ marginRight: '0.5rem' }} /> EIA</Link></li>
                {/* <li><Link to="/tank-testing-certificate" className={location.pathname === '/tank-testing-certificate' ? 'active' : ''}><FaCaretRight style={{ marginRight: '0.5rem' }} />Tank Testing Certificate (Explosive)</Link></li> */}

              </div>
            </div>
          </li>
          {/* <li><Link to="/testimonials">Testimonials</Link></li> */}
          <li><Link to="/">Testimonials</Link></li>
          <li><Link to="/contact-us">Contact</Link></li>
          
        </ul>
        <div className='iso_btc'>
        <IsoCertificateBatch/>
        </div>
       
      </div>
    </nav>
  );
};

export default MegaMenuNavbar;

